<script>
	import next from 'array-next'
	import prev from 'array-previous'
	import { fade } from 'svelte/transition'
	import { sineInOut } from 'svelte/easing'
	import loadjs from 'loadjs'

	export let slider = []
	// console.log('slider:', slider)

	let activeShow = slider[0]

	let loadedImages = [activeShow.img]

	function nextShow() {
		activeShow = next(slider, activeShow)
	}
	function prevShow() {
		activeShow = prev(slider, activeShow)
	}

	function loadImages(images) {
		if (!~loadedImages.indexOf(images[0])) {
			loadjs(images.map(url => `img!${url}`))
			loadedImages = loadedImages.concat(images)
		}
	}

	let containerWidth = 0

	let startX
	let startY

	const touchstart = ({ changedTouches }) => {
		startX = changedTouches[0].pageX
		startY = changedTouches[0].screenY
	}
	const touchend = ({ changedTouches }) => {
		const distX = changedTouches[0].pageX - startX
		const distY = changedTouches[0].screenY - startY
		if (Math.abs(distX) > Math.abs(distY)) {
			if (distX < -80) {
				nextShow()
			} else if (distX > 80) {
				prevShow()
			}
		}
	}
</script>

<div
	class="showcase-wrap"
	data-no-panel
	on:touchstart={touchstart}
	on:touchend={touchend}
	bind:clientWidth={containerWidth}>
	<div class="hs-backgrounds" class:wide-screen={containerWidth > 1800}>
		{#each [activeShow] as show (show.img)}
			{#if show.useVideo == true}
				<iframe
					src="https://www.youtube.com/embed/{show.videoID}?autoplay=1"
					frameborder="0"
					allow="autoplay"
					title="video" />
			{:else}
				<div
					in:fade={{ duration: 350, easing: sineInOut }}
					out:fade={{ duration: 250, easing: sineInOut, delay: 100 }}
					style="background-image: url({show.img})">
					<div style="background-image: url({show.img})" />
					{#if show.url}
						<a href={show.url}>
							{#if !show.imgAlt == ''}
								<h2 class="sr-only">{show.imgAlt}</h2>
							{:else}
								<h2 class="sr-only">{show.imgTitle}</h2>
							{/if}
						</a>
					{/if}
					{#if show.start.year !== '1970'}
						<span
							class="publish-date"
							style="background: {show.dateColors.background}; color: {show.dateColors.text}">
							<strong>
								{#if show.start.month === show.end.month}
									{show.start.month} {show.start.day}-{show.end.day}
								{:else}
									{show.start.monthAbbr} {show.start.day} - {show.end.monthAbbr}
									{show.end.day}
								{/if}
							</strong>
							<span>//</span>
							{show.end.year}
						</span>
					{/if}
				</div>
			{/if}
		{/each}
		<button
			class="prev"
			on:click={() => {
				prevShow()
				loadImages([prev(slider, activeShow).img])
			}}
			on:mouseenter={() => loadImages([prev(slider, activeShow).img])}>
			<span>
				<svg>
					<path
						fill="#FFF"
						d="M22 70L4 136a1 1 0 01-3 0l18-67L1 2a1 1 0 113 0l18 66v2z" />
				</svg>
				<svg>
					<path
						fill="#FFF"
						d="M22 70L4 136a1 1 0 01-3 0l18-67L1 2a1 1 0 113 0l18 66v2z" />
				</svg>
			</span>
		</button>
		<button
			class="next"
			on:click={() => {
				nextShow()
				loadImages([next(slider, activeShow).img])
			}}
			on:mouseenter={() => loadImages([next(slider, activeShow).img])}>
			<span>
				<svg>
					<path
						fill="#FFF"
						d="M22 70L4 136a1 1 0 01-3 0l18-67L1 2a1 1 0 113 0l18 66v2z" />
				</svg>
				<svg>
					<path
						fill="#FFF"
						d="M22 70L4 136a1 1 0 01-3 0l18-67L1 2a1 1 0 113 0l18 66v2z" />
				</svg>
			</span>
		</button>
	</div>

	<div class="showcase-dots">
		{#each slider as show}
			<button
				on:click={() => (activeShow = show)}
				on:mouseenter={() => loadImages([show.img])}
				class:active={show === activeShow}>
				{#if !show.imgAlt == ''}
					<span class="sr-only">{show.imgAlt}</span>
				{:else}
					<span class="sr-only">{show.imgTitle}</span>
				{/if}
			</button>
		{/each}
	</div>
</div>
